import {get, includes} from 'lodash';
import {connect} from 'react-redux';
import AgentNotes from './AgentNotes';
import * as listingsActions from 'actionCreators/comparableListings';
import * as rentalsActions from 'actionCreators/comparableRentals';
import * as salesActions from 'actionCreators/comparableSales';
import {selectPropertyNotes, updatePropertyNotes} from 'ducks/propertyNotes';
import {changeUserSettings} from 'ducks/userSettings';
import {fetchPropertyNotes} from 'actionCreators/propertyFetchingActions';
import {getFetchingFromState} from 'lib/PropertyUtils';

const comparableTypeToStore = {
  listings: {store: 'comparableListings', actions: listingsActions},
  sales: {store: 'comparableSales', actions: salesActions},
  rentals: {store: 'comparableRentals', actions: rentalsActions},
};

const mapStateToProps = (state, ownProps) => {
  const {featureFlags} = state;
  const propertyId = ownProps.propertyId;
  const propertyNote = state.propertyNotes[propertyId] || {};
  const isLoading = getFetchingFromState({
    propertyId,
    comparableType: ownProps.comparableType,
    state,
    updateFields: ['propertyNotes']
  });
  const reportType = state.reportType.value;
  const storeName = comparableTypeToStore[ownProps.comparableType].store;
  const comparableItems = state[storeName];
  const userSettings = state.userSettings || {};
  return {
    isLoading,
    featureFlags,
    reportType,
    propertySelected: comparableItems.selected.indexOf(propertyId) !== -1,
    notes: propertyNote.note || '',
    notesTitle: userSettings.notesTitle,
    hideNotesSelected: ownProps.hideNotesSelected,
    notesSelected: get(propertyNote, ['selected', ownProps.comparableType]) || false,
    enabled: reportType === 'soi' ? state.featureFlags.showNotesToVendorsOnSoi : true,
    featured: includes(comparableItems.featured, propertyId),
    showFeatureProperty: ownProps.showFeatureProperty || false,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const {propertyId, comparableType} = ownProps;
  const actions = comparableTypeToStore[comparableType].actions;

  return {
    onFetchNotes: () => {
      dispatch(fetchPropertyNotes({propertyId, comparableType}));
    },
    onNotesSelected: (selected) => dispatch(selectPropertyNotes(propertyId, comparableType, selected, true)),
    onNotesChange: (note) => dispatch(updatePropertyNotes(propertyId, note)),
    onAddFeature: () => dispatch(actions.featureProperty(propertyId, true)),
    onRemoveFeature: () => dispatch(actions.removeFeatureProperty(propertyId)),
    onNotesTitleChange: (title, reportType) => dispatch(changeUserSettings({notesTitle: title}, reportType)),
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    onNotesTitleChange: (title) => dispatchProps.onNotesTitleChange(title, stateProps.reportType),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(AgentNotes);